import {useEffect, useState} from 'react';

import * as net from 'util/Net';

export interface ContentLoaderResult {
  content: string | null;
  isLoading: boolean;
  error: string | null;
}

const IDLE_STATE: ContentLoaderResult = {content: null, isLoading: false, error: null};
const LOADING_STATE: ContentLoaderResult = {content: null, isLoading: true, error: null};

function toContentString(result: unknown): string {
  if (result == null) {
    return '';
  }
  if (typeof result === 'string') {
    return result;
  }
  return JSON.stringify(result, null, 2);
}

export function useTextContentFromUrl(url: string | null): ContentLoaderResult {
  const [state, setState] = useState<ContentLoaderResult>(url != null ? LOADING_STATE : IDLE_STATE);

  useEffect(() => {
    if (url == null) {
      setState(IDLE_STATE);
      return;
    }
    let cancelled = false;
    setState(LOADING_STATE);
    net
      .getPromise(url)
      .then((result: unknown) => {
        if (!cancelled) {
          setState({content: toContentString(result), isLoading: false, error: null});
        }
      })
      .catch(() => {
        if (!cancelled) {
          setState({content: null, isLoading: false, error: 'Failed to load file content.'});
        }
      });
    return () => {
      cancelled = true;
    };
  }, [url]);

  return state;
}
